import { Modal, Input, Form, Button, message, Select } from "antd";
import { useEffect, useState } from "react";
import API from "../../../services/API";
import LoaderComponent from "../../Loader";
import { PAYMENT_PRODUCT_TYPE } from "../../../constants/AppConstants";

const { Option } = Select;

function RefundModal({
   refundModalVisible,
   closeRefundModal,
   data,
   userId,
   referenceId,
   stripeChargeId,
   paymentProductType,
   refetchUserData,
 }) {
  const [visible, setVisible] = useState(false);
  const [modalLoading, showModalLoading] = useState(false);
  const [plaidAccounts, setPlaidAccounts] = useState([]);
  const [plaidLinkAllowed, setPlaidLinkAllowed] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    setVisible(refundModalVisible);
  }, [refundModalVisible]);
  
  useEffect(() => {
    plaidAccountDetails();
  }, []);

  useEffect(() => {
    form.setFieldsValue({});
  }, [data, form]);

  
  const plaidAccountDetails = async () => {
    try {
      let res = await API.getPlaidAccountDetails(userId);
      // For subscription Checkout-ACH refunds we deliberately surface inactive/expired accounts
      // too — the whole reason an agent picks a destination here is that the original Plaid link
      // broke (AVADEV-3253). Other product types keep the active-only filter.
      const includeInactiveAccounts =
        paymentProductType === PAYMENT_PRODUCT_TYPE.SUBSCRIPTION && data?.paymentMode === "CHECKOUT_ACH";
      const accountsWithKey = res.plaidConnections
          .filter((conn) => includeInactiveAccounts || conn.isActive || conn.linkedToSila)
          .map((account) => ({
            ...account,
            key: account.id,
          }));
      setPlaidAccounts(accountsWithKey);
      setPlaidLinkAllowed(res.plaidLinkAllowed);
    } catch (error) {
      message.error("Unable to fetch Plaid Accounts");
      message.error(error?.response?.data?.error_message || error?.response?.data?.errorMessage);
    }
  };

  useEffect(() => {
      plaidAccountDetails();
  }, []);


  const closeModal = () => {
    setVisible(false);
    closeRefundModal(false);
  };

  const triggerSubmitBtn = () => {
    // document.getElementById("submit-refund-amount").click();
    form.submit();
  };

  const refundUser = async (payload) => {
    console.log('payload', payload);

    showModalLoading(true);
    console.log("data", data);
    try {
      let response = await API.refundUser(
          userId,
          payload?.refundAmountToUser,
          referenceId,
          paymentProductType == PAYMENT_PRODUCT_TYPE.SAVINGS_BUILDER,
          paymentProductType,
          payload?.zendeskTicketNum,
          stripeChargeId,
          payload?.refundReason,
          payload?.plaidAccountId !== 0 ? payload?.plaidAccountId : null,
          payload?.refundAmountToCCAccount,
          paymentProductType == PAYMENT_PRODUCT_TYPE.SUBSCRIPTION && data?.paymentMode === "CHECKOUT_ACH" ? data?.transactionId : null
      );
      message.success(response?.successMessage);
      refetchUserData();
    } catch (ex) {
      message.error(
          ex?.response?.data?.error_message || ex?.response?.data?.errorMessage
      );
    } finally {
      closeRefundModal(false);
      showModalLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    message.error("Please see the validation errors");
  };

  return (
      <Modal
          title={"Issue Refund User"}
          centered
          mask={true}
          maskClosable={true}
          okText={"Refund"}
          destroyOnClose={true}
          closable={true}
          visible={visible}
          onOk={triggerSubmitBtn}
          onCancel={closeModal}
          className="confirm-modal"
          width={800}
      >
        {!modalLoading && (
            <Form
                name="basic"
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                onFinish={refundUser}
                form={form}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
              <Form.Item
                  label="Refund Amount"
                  name="refundAmountToUser"
                  extra="(To User Account)"
                  rules={[
                    {
                      required: true,
                      message: "Amount is required!",
                    },
                  ]}
              >
                <Input
                    placeholder="Amount"
                    type="number"
                    min={0}
                    step={0.01}
                />
              </Form.Item>
              
              {
                (
                  paymentProductType === PAYMENT_PRODUCT_TYPE.SAVINGS_BUILDER ||
                  (paymentProductType === PAYMENT_PRODUCT_TYPE.SUBSCRIPTION && data?.paymentMode === "CHECKOUT_ACH")
                 ) && (<>

                    <Form.Item
                      label="Plaid Account"
                      name="plaidAccountId"
                      extra={paymentProductType === PAYMENT_PRODUCT_TYPE.SUBSCRIPTION
                        ? "Leave on (Default) to reverse the original charge. Pick an account to override the destination — used when the original Plaid link has been revoked."
                        : undefined}
                    >
                      <Select
                        placeholder="Select Plaid Account"
                        disabled={plaidAccounts.length === 0}
                      >
                        <Option value={0}>{paymentProductType === PAYMENT_PRODUCT_TYPE.SUBSCRIPTION ? "(Default — reverse to original funding source)" : "(Latest)"}</Option>
                        { plaidAccounts && plaidAccounts.map((accounts) => <Option key={accounts.id} value={accounts.id}>{accounts.bankName} - {accounts.last4}</Option>)}
                      </Select>
                    </Form.Item>
                    </>)}
                    {(
                      paymentProductType === PAYMENT_PRODUCT_TYPE.SAVINGS_BUILDER
                    ) && (<>
                    <Form.Item
                      label="Transfer to Credit Card Account"
                      name="refundAmountToCCAccount"
                    >
                      <Input
                        placeholder="Amount"
                        type="number"
                        defaultValue={0}
                        min={0}
                        step={0.01}
                      />
                    </Form.Item>
                  </>)
              }

              <Form.Item
                  label="Zendesk Ticket #"
                  name="zendeskTicketNum"
                  rules={[
                    {
                      required: true,
                      message: "Ticket no. is required!",
                    },
                  ]}
              >
                <Input />
              </Form.Item>

              <Form.Item label="Refund Reason" name="refundReason">
                <Input />
              </Form.Item>

              <Form.Item
                  wrapperCol={{
                    offset: 8,
                    span: 16,
                  }}
              >
                <Button
                    type="primary"
                    htmlType="submit"
                    hidden
                    id="submit-refund-amount"
                >
                  Submit
                </Button>
              </Form.Item>
            </Form>
        )}
        {modalLoading && <LoaderComponent tip={"Updating account"} />}
      </Modal>
  );
}

export default RefundModal;
